import React, { useState, useEffect } from 'react';
import keepAliveService from '../../services/keepAlive';

function KeepAliveStatus() {
  const [status, setStatus] = useState(keepAliveService.getStatus());
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Update status every 30 seconds
    const interval = setInterval(() => {
      try {
        setStatus(keepAliveService.getStatus());
      } catch (error) {
        console.error('KeepAliveStatus: Error updating status:', error);
      }
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // ✅ ONLY show to developers and admins - INVISIBLE to regular users
  const isDevelopment = import.meta.env.DEV;
  const isAdmin = status.userType === 'admin';
  
  // INVISIBLE to regular users in production
  if (!isDevelopment && !isAdmin) return null;
  if (!status.isActive || !isVisible) return null;

  const handleClose = () => setIsVisible(false);
  const handleForcePing = async () => {
    try {
      await keepAliveService.forcePing();
      // Update status immediately after force ping
      setStatus(keepAliveService.getStatus());
    } catch (error) {
      console.error('KeepAliveStatus: Force ping failed:', error);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      background: status.backendSleeping ? '#fee2e2' : '#dcfce7',
      color: status.backendSleeping ? '#dc2626' : '#166534',
      padding: '12px 16px',
      borderRadius: '8px',
      fontSize: '12px',
      zIndex: 9999,
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      minWidth: '200px',
      fontFamily: 'monospace',
      opacity: 0.85
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '8px' 
      }}>
        <strong>{isDevelopment ? '🔧 DEV: Keep-Alive' : '🔄 Keep-Alive'}</strong>
        <button 
          onClick={handleClose}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: 'inherit', 
            cursor: 'pointer', 
            fontSize: '16px',
            padding: '0',
            margin: '0'
          }}
          title="Close keep-alive status"
        >
          ×
        </button>
      </div>
      
      <div>👤 User: {status.userType || 'unknown'}</div>
      <div>
        📡 Status: {status.backendSleeping ? '⚠️ Sleeping' : '✅ Active'}
      </div>
      <div>🕐 Last: {status.lastPingTimeFormatted || 'Never'}</div>
      <div>❌ Fails: {status.failureCount || 0}</div>
      
      <button 
        onClick={handleForcePing}
        style={{
          marginTop: '8px',
          padding: '4px 8px',
          background: status.backendSleeping ? '#dc2626' : '#166534',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '11px'
        }}
        title="Force ping backend now"
      >
        Force Ping
      </button>
    </div>
  );
}

export default KeepAliveStatus;
